import React from "react";
import './styles.css'

const Timeline = ({ data = [] }) => {
    return (
        <ul className="timeline">
            {data.map(e =>
                <li className="timeline-item mb-4">
                    <p className="text-muted mb-2">{e.datetime}</p>
                    <h5 >{e.title}</h5>
                    <p className="text-muted">
                        {e.desc}
                    </p>
                </li>
            )}
        </ul>
    );
}

export default Timeline;
